import { useMutation, useQueryClient } from 'react-query';
import { createSlideCopy, saveSlide } from 'chalktalk-react/apis/learn_hub';
import { useParams } from 'react-router-dom';

export const useCreateLessonSlide = (
  userId?: string,
  lessonNodeId?: string,
  callbacks?: {
    onSuccess?: () => void;
    onError?: (error: string) => void;
  },
) => {
  const queryClient = useQueryClient();
  const { sectionId } = useParams();

  return useMutation({
    mutationFn: () => {
      if (!lessonNodeId) {
        return Promise.reject(new Error('Lesson ID is required to create a slide.'));
      }
      if (!userId) {
        return Promise.reject(new Error('User ID is required to create a slide.'));
      }
      return createSlideCopy(sectionId as string, userId, lessonNodeId);
    },
    onSuccess: () => {
      // Invalidate and refetch the specific lesson slide query
      const key = `${userId}-${sectionId}-${lessonNodeId}`;
      queryClient.invalidateQueries({ queryKey: ['lessonSlides', key] });
      callbacks?.onSuccess?.();
    },
    onError: ({ response }) => {
      console.error('Error creating lesson slide:', response?.data?.error);
      callbacks?.onError?.(response?.data?.error);
    },
  });
};

export const useSaveSlide = (
  userId?: string,
  lessonNodeId?: string,
  callbacks?: {
    onSuccess?: () => void;
    onError?: (error: string) => void;
  },
) => {
  const queryClient = useQueryClient();
  const { sectionId } = useParams();

  return useMutation({
    mutationFn: () => {
      if (!lessonNodeId) {
        return Promise.reject(new Error('Lesson ID is required to save a slide.'));
      }
      if (!userId) {
        return Promise.reject(new Error('User ID is required to save a slide.'));
      }
      return saveSlide(sectionId as string, userId, lessonNodeId);
    },
    onSuccess: () => {
      // Invalidate and refetch the specific lesson slide query
      const key = `${userId}-${sectionId}-${lessonNodeId}`;
      queryClient.invalidateQueries({ queryKey: ['lessonSlides', key] });
      callbacks?.onSuccess?.();
    },
    onError: (error: any) => {
      console.error('Error saving lesson slide:', error.response?.data?.error);
      callbacks?.onError?.(error.response?.data?.error);
    },
  });
};
